import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Industries } from './components/Industries';
import { Testimonials } from './components/Testimonials';
import { CaseStudies } from './components/CaseStudies';
import { Team } from './components/Team';
import { ContactCTA } from './components/ContactCTA';
import { Footer } from './components/Footer';
import { LanguageProvider } from './LanguageContext';
import { LanguageModal } from './components/LanguageModal';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-slate-800 selection:bg-electric/30 selection:text-navy" data-id="element-1">
        <LanguageModal data-id="element-2" />
        <Navbar data-id="element-3" />

        <main data-id="element-4">
          <Hero data-id="element-5" />
          <Services data-id="element-6" />
          <WhyChooseUs data-id="element-7" />
          <Process data-id="element-8" />
          <Industries data-id="element-9" />
          <Testimonials data-id="element-10" />
          <CaseStudies data-id="element-11" />
          <ContactCTA data-id="element-12" />
        </main>

        <Footer data-id="element-13" />
      </div>
    </LanguageProvider>;
}